<template>
    <div class="no-br"><slot></slot></div>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
<style scoped>
.no-br {
    white-space: nowrap;
}
</style>
